import {z} from "zod";
import {imageSchema} from "@/images/ImageSchema.ts";


const dungeonSettingsSchema = z.object({
    dungeonId: z.string().min(1, "Dungeon erforderlich"),
    levelId: z.uuid(),
    sightRadiusMeters: z.number().int().min(3).max(36).default(36),
    showGrid: z.boolean().default(false),
    gridOpacity: z.number().min(0).max(1).default(0.5),
})

const viewPortSchema = z.object({
    centerX: z.number(),
    centerY: z.number(),
    visibleWidth: z.number().positive(),
    visibleHeight: z.number().positive(),
})

export const encounterSchema = z.object({
    id: z.uuid(),
    campaignId: z.uuid("Kampagne erforderlich"),
    name: z.string().min(3, "Name erforderlich"),
    round: z.number().min(0).default(0),
    viewPort: viewPortSchema,
    dungeonSettings: dungeonSettingsSchema,
    coverImage: imageSchema.nullish(),
})


export type EncounterFormInput = z.input<typeof encounterSchema>;
export type EncounterFormOutput = z.output<typeof encounterSchema>;
